import { GridColDef } from "@mui/x-data-grid";
import { t } from "i18next";
import DataGridApi from "../../../../components/dataGridApi";
import { ISpreadsheet } from "../../../../interfaces/ISpreadsheet";
import { CONFIG } from "../../../../services/config";

interface Props {
  spreadsheet?: ISpreadsheet;
}

export default function GarantiaPadrao({ spreadsheet }: Props) {
  const columns: GridColDef[] = [
    {
      field: "modelYear",
      flex: 1,
      headerName: t("digitalServicePlan.modelYear"),
      headerClassName: "header-style",
    },
    {
      field: "limitMonth",
      flex: 1,
      headerName: t("digitalServicePlan.limitMonth"),
      headerClassName: "header-style",
    },
  ];
  return (
    <DataGridApi
      params1="&param="
      labelParams1="Ano do modelo"
      host={CONFIG.SOB_API}
      endPoint={`excel/warranty/${spreadsheet?.id}?`}
      columnsData={columns}
    />
  );
}
